export function setCurrentCheck(payload) {
    return { type: 'SET_CURRENT_CHECK', payload }
};
export function setCompany(payload) {
    return { type: 'SET_COMPANY', payload }
};